import Paragraph from './Paragraph';
import Title from './Title';

const ParagraphMain = {
  Title,
  Paragraph,
};

export default ParagraphMain;
